import { Reveal } from "./Reveal";

const METRICS = [
  { metric: "14,200+", label: "Full-Stack Apps Deployed" },
  { metric: "4.2 Min", label: "Average Idea-to-URL Velocity" },
  { metric: "100%", label: "Exportable Source Code" },
  { metric: "99.98%", label: "Edge Runtime Uptime SLA" },
];

export const Stats = () => (
  <section id="stack" className="scroll-mt-24 border-t border-[#e8e8e4] py-20 sm:py-24">
    <div className="mx-auto max-w-7xl px-6">
      <div
        data-testid="metrics-stats-grid"
        className="card-soft grid gap-px overflow-hidden rounded-3xl bg-[#e8e8e4] sm:grid-cols-2 lg:grid-cols-4"
      >
        {METRICS.map((m, i) => (
          <Reveal key={m.label} delay={i * 0.08} className="h-full">
            <div className="flex h-full flex-col items-start bg-white p-8 sm:p-10">
              <span className="font-display text-4xl font-bold text-[#0b0f1a] sm:text-5xl">{m.metric}</span>
              <span className="mt-4 flex items-center gap-2 font-mono text-[10px] uppercase tracking-[0.2em] text-slate-500">
                <span className="h-1.5 w-1.5 rounded-full bg-[#2563eb]" />
                {m.label}
              </span>
            </div>
          </Reveal>
        ))}
      </div>
    </div>
  </section>
);
